import en from './en';
import es from './es';

export { en, es };

/**
 *
 *  Example usage:
 *
 *  t('login:greeting')
 *
 *  Prints @greeting string from @login parameter of current language
 *
 * */



// WEBPACK FOOTER //
// ./src/i18n/translations/index.js